if (!customElements.get('custom-showcase')) {
  customElements.define(
    'custom-showcase',
    class CustomShowcase extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        if (!this.enableSlider) return;

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderInstance = false;

        this.initSlider();
        this.setupEventListeners();
      }

      initSlider() {
        const spaceBetween = parseInt(this.dataset.itemGap);

        this.sliderOptions = {
          slidesPerView: 'auto', // changed from 1 to 'auto'
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector('.swiper-button-next'),
            prevEl: this.section.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.section.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          breakpoints: {
            768: {
              slidesPerView: 'auto', // keep 'auto' for tablet+ (with wider slide gaps)
              spaceBetween: spaceBetween * 2,
            },
          },
          autoHeight: true,
          loop: true,
          threshold: 2,
          effect: 'slide',
          speed: 500,
          grabCursor: true,
          centeredSlides: false,
          watchOverflow: true
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.querySelector('.swiper'), this.sliderOptions);
        this.sliderInstance.init();

        const images = this.querySelectorAll('img');
        images.forEach(img => {
          img.addEventListener('load', () => {
            if (this.sliderInstance) {
              this.sliderInstance.slider.update();
            }
          });
        });
      }

      setupEventListeners() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            if (this.sliderInstance && slide) {
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            }
          });
        });

        this.resizeObserver = new ResizeObserver(() => {
          if (this.sliderInstance) {
            this.sliderInstance.slider.update();
          }
        });

        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.sliderInstance) {
          this.sliderInstance.destroy();
        }
      }
    }
  );
}
